import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';
import { Button } from 'app/src/elements/buttons';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { sellerOptions, saleOptions } from './filterOptions';

import { cardStyles as styles } from './index';
import { SEND_SELLER_DETAIL_REPORT } from './queries';
import DateInput from 'app/src/elements/DateInput';

const SalesReport = ({ data }) => {
  const [sellerId, setSellerId] = useState();
  const [saleId, setSaleId] = useState();
  const [month, setMonth] = useState();

  const [sendSellerDetailReport] = useMutation(SEND_SELLER_DETAIL_REPORT);

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'seller-detail-report',
      params: {
        'sale-id': saleId, 'seller-id': sellerId, 'month': month
      },
    });
  };

  const handleEmail = () => {
    if (!sellerId) { return; }

    if (confirm('Email Report to Seller?')) {
      sendSellerDetailReport({
        variables: { sellerId, saleId, month }
      });
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Seller Detail Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <SearchableSelect
        placeholder="Select Seller"
        options={sellerOptions(data)}
        value={sellerId}
        onChange={setSellerId}
      />
      <Text style={styles.label}>Sale (optional):</Text>
      <SearchableSelect
        placeholder="Select Sale"
        options={saleOptions(data)}
        value={saleId}
        onChange={setSaleId}
      />
      <Text style={styles.label}>
        Month (choose any date in month, optional):
      </Text>
      <DateInput
        style={styles.select}
        onChange={e => setMonth(e.target.value)}
        value={month || ''}
      />

      <DownloadButton handleDownload={handleDownload}>
        <Button
          label="Email"
          style={
            sellerId ? { width: 120 } : { backgroundColor: 'gray', width: 120 }
          }
          onPress={handleEmail}
        />
      </DownloadButton>
    </View>
  );
};

export default SalesReport;
